import React, { useEffect, useState, useCallback, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Breadcrums from "../../common/breadcrumbs";
import Loader from "../../common/loader";
import CustomPagination from "../../common/custompagination";
import { TrimText } from "../../../../utils/commonfunction";
import {
  TempleBookingList,
  AssignRunner,
  ListRunner,
} from "../../services/templeBooking.services";
import Swal from "sweetalert2";
import { SWAL_SETTINGS ,showTempleBookingFilterlist } from "../../../../utils/Constants";
import Select from "react-select";
import ReactDOM from "react-dom/client";

const TempleBooking = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [list, setList] = useState([]);
  const [loader, setLoader] = useState(true);
  const [page, setPage] = useState(1);
  const [itemPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [globalSearch, setGlobalSearch] = useState("");
  const [refresh, setRefresh] = useState(false);
  const [search, setSearch] = useState({});
  

  const breadcrumbs = [
    { title: t("link_dashboard"), url: "/admin/dashboard" },
    { title: t("Temple"), url: "/admin/temples/list/1" },
    { title: t("Temple Bookings"), url: "" },
  ];

  // ================= FETCH BOOKINGS =================
  const fetchBookings = useCallback(() => {
    setLoader(true);

    const formData = new FormData();
    formData.append("page", page);
    formData.append("per_page", itemPerPage);
    formData.append("global_search", globalSearch);
    Object.keys(search).forEach((key) => {
      formData.append(key, search[key]);
    });

    TempleBookingList(formData)
      .then((res) => {
        setList(res?.data?.list || []);
        setTotalRecords(res?.data?.total_records || 0);
      })
      .finally(() => setLoader(false));
  }, [page, itemPerPage, globalSearch,search]);

  useEffect(() => {
    fetchBookings();
  }, [fetchBookings, refresh]);

  const resetFilter = () => {
    setGlobalSearch("");
    setPage(1);
    prepareSearch();
    setSearch({});
  };

  // ================= ASSIGN RUNNER =================

  const handleAssignRunner = (templeServiceHistoryId) => {
    let selectedRunner = null;

    Swal.fire({
      title: "Assign Runner",
      html: `<div id="runner-select"></div>`,
      showCancelButton: true,
      confirmButtonText: "Assign",
      allowOutsideClick: false,
      allowEscapeKey: false,

      didOpen: () => {
        const mountNode = document.getElementById("runner-select");
        const root = ReactDOM.createRoot(mountNode);

        const RunnerSelect = () => {
          const [options, setOptions] = useState([]);
          const [loading, setLoading] = useState(false);
          const debounceRef = useRef(null);

          const fetchRunners = async (search = "") => {
            setLoading(true);
            try {
              const res = await ListRunner({ search });
              const list = res?.data || [];

              setOptions(
                list.map((r) => ({
                  value: r._id,
                  label: `${r.name} - ${r.city}`,
                }))
              );
            } finally {
              setLoading(false);
            }
          };

          useEffect(() => {
            fetchRunners("");
          }, []);

          const handleInputChange = (value, meta) => {
            if (meta.action !== "input-change") return;

            if (debounceRef.current) {
              clearTimeout(debounceRef.current);
            }

            debounceRef.current = setTimeout(() => {
              fetchRunners(value || "");
            }, 500);
          };

          return (
            <Select
              placeholder="Search runner..."
              isLoading={loading}
              options={options}
              onInputChange={handleInputChange}
              onChange={(val) => (selectedRunner = val)}
              menuPortalTarget={document.body}
              menuPosition="fixed"
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
            />
          );
        };

        root.render(<RunnerSelect />);
      },

      preConfirm: () => {
        if (!selectedRunner) {
          Swal.showValidationMessage("Please select a runner");
          return false;
        }
        return selectedRunner;
      },
    }).then((result) => {
      if (!result.isConfirmed) return;

      AssignRunner({
        templeservicehistory_id: templeServiceHistoryId,
        runner_id: result.value.value,
      }).then((res) => {
        Swal.fire({
          icon: res?.success ? "success" : "error",
          text: res?.message,
          ...SWAL_SETTINGS,
        });
        setRefresh((p) => !p);
      });
    });
  };

  // ================= GROUP BY TEMPLE =================
  const groupedBookings = list.reduce((acc, booking) => {
    const templeName = booking.temple?.templeName || "Unknown Temple";
    acc[templeName] = acc[templeName] || [];
    acc[templeName].push(booking);
    return acc;
  }, {});

  const renderStatus = (status) => {
    const map = {
      pending: "bg-warning",
      upcoming: "bg-primary",
      assigned: "bg-info",
      completed: "bg-success",
      cancelled: "bg-danger",
    };
    return (
      <span
        className={`btn text-white text-capitalize ${map[status] || "bg-secondary"}`}
      >
        {t(status)}
      </span>
    );
  };

  const prepareSearch = (key, value) => {
    let sr = { ...search };
    if (String(value).length > 0) {
      sr[key] = value;
    } else {
      delete sr[key];
    }
    setSearch(sr);
  };

  function viewfunction(data) {
    navigate(`/admin/temple-booking/view/${data}`);
  }

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="card custom-card">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h6 className="main-content-label">{t("Temple Booking")}</h6>
            <div className="d-flex align-items-center">
              <div className="form-group mb-0 me-3">
                <div className="form-group mb-0 rangepicker_container filter_design">
                  <i className="fa fa-search calender_icon"></i>
                  <input
                    type="search"
                    className="form-control"
                    value={globalSearch}
                    placeholder={t("input_placeholder_search")}
                    onChange={(e) => setGlobalSearch(e.target.value)}
                  />
                </div>
              </div>
                <div className="me-3">
                  <div className="form-group mb-0 filter_icon_container filter_design">
                    <i className="fa fa-filter mr-2 filter_icon"></i>
                    <div className="select-down-arrow">
                      <select
                        className="form-control cp"
                        onChange={(e) => prepareSearch("status", e.target.value)}
                        id="defaultstatus"
                      >
                        {showTempleBookingFilterlist.map((option, i) => (
                          <option key={i} value={option.status__id}>
                            {t(option.name)}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>         
                <button
                type="reset"
                className="btn btn-warning me-2"
                onClick={resetFilter}
              >
                {t("btn_reset_filter")}
              </button>
            </div>
          </div>
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>#</th>
                <th>User</th>
                <th>Service</th>
                <th>Duration</th>
                <th>Price</th>
                <th>Paybale Amount</th>
                <th>Status</th>
                <th>Runner</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {loader ? (
                <tr>
                  <td colSpan={9} className="text-center">
                    <Loader />
                  </td>
                </tr>
              ) : list.length === 0 ? (
                    <tr>
                      <td colSpan={9} className="text-center">
                        {t("msg_no_records")}
                      </td>
                    </tr>
              ) : (
                Object.keys(groupedBookings).map((temple, i) => (
                  <React.Fragment key={temple + i}>
                    <tr>
                      <td colSpan={9} className="fw-bold bg-light">
                        {temple}
                      </td>
                    </tr>
                    {groupedBookings[temple].map((b, idx) => (
                      <tr key={b._id}>
                        <td>{idx + 1}</td>
                        <td>{b.booking_user?.name || "-"}</td>
                        <td>{TrimText(b.service?.name || "-", 20)}</td>
                        <td>{b.service?.duration || "-"} Mintues</td>
                        <td>₹ {b.service?.price ?? 0}</td>
                        <td>₹ {b.charges?.total_amount ?? 0}</td>
                        <td>{renderStatus(b.order_status)}</td>
                        <td>
                          {b.runner?.name ? (
                            <span>{b.runner.name}</span>
                          ) : (
                            <button
                              className="btn btn-info btn-sm"
                              onClick={() => handleAssignRunner(b._id)}
                            >
                              Assign Runner
                            </button>
                          )}
                        </td>
                        <td>
                          <button
                            className="btn ripple btn-main-primary signbtn me-2"
                            onClick={() => {
                              viewfunction(b._id);
                            }}
                          >
                            {t("btn_view")}
                          </button>
                        </td>
                      </tr>
                    ))}
                  </React.Fragment>
                ))
              )}
            </tbody>
          </table>
          <div id="example1_info" role="status" aria-live="polite">
            <b>
              {t("msg_total_records")} : {totalRecords}
            </b>
          </div>
          {totalRecords > 0 && (
            <CustomPagination
              datalength={totalRecords}
              itemperpage={itemPerPage}
              currentPage={page}
              setPage={setPage}
              pageRoute={[
                {
                  name: "PageTable",
                  path: "/admin/temple-booking/list",
                },
              ]}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default TempleBooking;
